import React from "react";

const ChangeCheckContext = React.createContext({
    changeCheckReset: false,
    disable: false
});

export default ChangeCheckContext
